import {useAppDispatch} from "../hooks";
import warehouseServices from "../services/warehouseServices";
import {setWarehousesList} from "../slices/warehouseSlise";

export const useFetchWarehouses = () => {
    const dispatch = useAppDispatch();

    return async () => {
        try {
            const data = await warehouseServices.getWarehouses();
            dispatch(setWarehousesList(data));
        } catch (error) {
            console.error(error);
        }
    };
};
